import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId, useCurrentJobId } from "@/hooks";
import { httpClient } from "@/lib/http";
import { CandidacyStatus, HttpResponse } from "@/types";

export function useGetCandidacyCountsByStatus() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  return useQuery({
    queryKey: ["candidacies/counts_by_status", currentCompanyId, currentJobId],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/candidacies/counts_by_status`;
      const res = await httpClient.get<
        Record<CandidacyStatus, number>,
        HttpResponse<Record<CandidacyStatus, number>>
      >(path);
      return res.data;
    },
  });
}
